import React from 'react';
import { PropTypes } from 'prop-types';
import { PRIMARY_COLOR, DARK_PRIMARY_COLOR } from '../../constants';
import CustomCircleLoader from './CustomCircleLoader';
import { useSelector } from 'react-redux';
import s from './Loader.css';


const CircleLoader = ({ show }) => {
    const theme = useSelector(state => state?.currency?.theme)
    return (
        show ?
            <div className={cx(s.textCenter)}>
                <CustomCircleLoader size={48} singleColor={theme === 'dark' ? DARK_PRIMARY_COLOR : PRIMARY_COLOR} />
            </div> : <div />
    )
}

CircleLoader.propTypes = {
    show: PropTypes.bool.isRequired
};

CircleLoader.defaultProps = {
    show: false
};


export default CircleLoader;
